import React from 'react';

interface FormFieldProps {
  id: string;
  label: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  placeholder?: string;
}

export function FormField({ 
  id, 
  label, 
  type, 
  value, 
  onChange, 
  required, 
  placeholder 
}: FormFieldProps) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="block text-sm font-medium text-gray-900 dark:text-gray-100">
        {label} {required && <span className="text-primary-500">*</span>}
      </label>
      <input
        type={type}
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        className="w-full px-4 py-2.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg 
          focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 dark:focus:border-primary-400
          placeholder:text-gray-400 dark:placeholder:text-gray-500
          text-gray-900 dark:text-gray-100
          transition-all duration-200
          hover:border-gray-400 dark:hover:border-gray-500"
      />
    </div>
  );
}